import { render, staticRenderFns } from "./SettingsLanguages.vue?vue&type=template&id=156e597a&scoped=true&lang=pug&"
import script from "./SettingsLanguages.vue?vue&type=script&lang=ts&"
export * from "./SettingsLanguages.vue?vue&type=script&lang=ts&"
import style0 from "./SettingsLanguages.vue?vue&type=style&index=0&id=156e597a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156e597a",
  null
  
)

export default component.exports